<template>
  <v-card class="rounded-card card-shadow fill-height" color="secondary">
    <v-card-text class="text--primary pa-5">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-icon size="100" color="white">mdi-alert-outline</v-icon>
          <div class="d-flex flex-column justify-center white--text">
              <span class="headline font-weight-bold ml-3">
              {{ total }} alertas de preço
            </span>
            <div class="ml-3">
              Veja os alertas criados para suas ofertas e faça ações para vender mais.
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    alertas: Object,
  },
  computed: {
    total() {
      if (!this.alertas || !this.alertas.total) {
        return 0;
      }
      return this.alertas.total;
    },
  },
};
</script>
